export const osHome = 'https://www.opensolar.com'
export const termsLink_external = 'https://www.opensolar.com/terms-conditions'
export const privacyLink = 'https://www.opensolar.com/privacy'
export const osLiteSupportLink = 'https://support-lite.opensolar.com/hc/en-us'
export const WebinarLink = 'https://www.opensolar.com/webinars'
export const osSupportLink = { url: 'https://support.opensolar.com', locale: ['it', 'es', 'fr', 'nl', 'pl', 'sv'] }
export const JIRA_SUPPORT_TICKET_LINK = 'https://opensolar.atlassian.net/servicedesk/customer/portal/201'
export const JIRA_SUPPORT_REPORT_ISSUE_LINK =
  'https://opensolar.atlassian.net/servicedesk/customer/portal/201/group/210/create/336'
export const JIRA_SUPPORT_TARIFF_HARDWARE_LINK =
  'https://opensolar.atlassian.net/servicedesk/customer/portal/201/group/210/create/337'
export const JIRA_SUPPORT_QUESTION_LINK =
  'https://opensolar.atlassian.net/servicedesk/customer/portal/201/group/210/create/301'
export const solkunderLink = 'https://www.3quotes.eu/connect/opensolar'
export const PAYMENTS_PAGE_TITLE_HELPCENTER_URL =
  'https://support.opensolar.com/hc/en-us/sections/4407123896729-Payment-Options'

export const changeOrderHelpCenterLink =
  'https://support.opensolar.com/hc/en-us/articles/9808231963407-How-to-create-a-Change-Order-or-Amendment-for-a-Sold-Project'
